export function onEnterWrapper<T extends HTMLElement>(
  fn: React.KeyboardEventHandler<T>
): React.KeyboardEventHandler<T> {
  return (event) => {
    if (event.key === 'Enter' && !event.repeat) {
      event.preventDefault();
      fn(event);
    }
  };
}
